import { SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import type { FormInputProps } from "../../types";
import {
  FormInputLabel,
  FormInputStyle,
  FormInputWrap,
} from "./FormInput.style";

const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      placeholderTxt,
      labelTxt,
      margin,
      errorState,
      inputValue,
      handleChange,
      flex,
      requiredField,
      handleKeyDown,
      maxInputLength,
      inputType,
      handleFocus,
      handleBlur,
      maxValue,
      minValue,
      autoComplete = "on",
      isDisabled,
      backgroundColor,
      hasError = false,
      showError = false,
    },
    ref
  ) => {
    const handleMouseWheel = (event: React.WheelEvent<HTMLInputElement>) => {
      // Blur the input to prevent scroll from changing number/date values.
      // Note: calling preventDefault() is not allowed inside passive wheel listeners.
      (event.target as HTMLInputElement).blur();
    };

    return (
      <FormInputWrap margin={margin} flex={flex}>
        {labelTxt && (
          <FormInputLabel>
            {labelTxt}
            {requiredField && (
              <SpanTag fontWeight="bold" color={theme.redText2}>
                *
              </SpanTag>
            )}
          </FormInputLabel>
        )}
        <FormInputStyle
          ref={ref}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          value={inputValue}
          hasError={hasError}
          id={labelTxt}
          placeholder={placeholderTxt}
          maxLength={maxInputLength}
          type={inputType}
          min={minValue}
          max={maxValue}
          onWheel={handleMouseWheel}
          autoComplete={autoComplete}
          inputWidth="100%"
          disabled={isDisabled}
          backgroundColor={backgroundColor}
        />
        {showError && errorState && (
          <SpanTag
            fontSize="xs"
            margin="4px 0 0"
            color={theme.redText}
            fontWeight="bold"
          >
            {errorState}
          </SpanTag>
        )}
      </FormInputWrap>
    );
  }
);

FormInput.displayName = "FormInput";

export default FormInput;
